import React from "react";
import PropTypes from "prop-types";
import { observer } from "mobx-react";
import classnames from "classnames/bind";

import FooterLink from "./FooterLink";

import footerLinks from "../../../../../links/footerLinks";

import styles from "../MainMenuDropdown.scss";

import { useStore } from "../../../../../connect";

const cx = classnames.bind(styles);

const licenseGroupIds = {
  CARRIERS: 1,
  CARGO_OWNERS: 2,
};

const Footer = ({ children, type, isMobile }) => {
  const { profile } = useStore();

  const billingLinkData = { ...footerLinks.billing };
  if (!profile.isPaidUser) {
    const urlParams = `?option=1&licenseCategory=${
      type === "carriers"
        ? licenseGroupIds.CARRIERS
        : licenseGroupIds.CARGO_OWNERS
    }`;

    billingLinkData.href = `${
      footerLinks.billing.href + urlParams
    }&utm_source=header&utm_campaign=new_header`;
  } else {
    billingLinkData.href += "?utm_source=header&utm_campaign=new_header";
  }

  return (
    <div className={cx("footer", { "is-mobile": isMobile })}>
      {children}
      {!isMobile ? (
        <div className={cx("float-right-link")}>
          <FooterLink isBlack={profile.isPaidUser} linkData={billingLinkData} />
        </div>
      ) : (
        <FooterLink isBlack={profile.isPaidUser} linkData={billingLinkData} />
      )}
    </div>
  );
};

Footer.propTypes = {
  children: PropTypes.node,
  isMobile: PropTypes.bool,
  type: PropTypes.oneOf(["carriers", "cargo-owners"]),
};

export default observer(Footer);
